import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { useFormContext } from 'context/FormContext';
import { ColunaDinamicaProps, LojaConfiguracao, OpcaoProps } from 'pages/cadastro/loja/types';

export function useGetColunasOpcoes(filterValue: string) {
    const { content, isLoading, setContent } = useFormContext();

    const originalList = content?.configuracaoPropriedadeOpcaoList || [];

    const filteredList = originalList.filter(
        (item: OpcaoProps) =>
            !filterValue ||
            item.dsConfiguracaoPropriedadeOpcao.toLowerCase().includes(filterValue.toLowerCase()) ||
            item.idConfiguracaoPropriedadeOpcao == Number(filterValue),
    );
    const handleRemoveOption = (idParaRemover: number) => {
        setContent((prevState: ColunaDinamicaProps) => {
            const novaLista = prevState.configuracaoPropriedadeOpcaoList?.filter(
                (item: any) => item.idConfiguracaoPropriedadeOpcao !== idParaRemover,
            );

            return {
                ...prevState,
                configuracaoPropriedadeOpcaoList: novaLista,
            };
        });
    };

    const handleEditOption = (opcaoEditada: OpcaoProps | null) => {
        setContent((prevState: ColunaDinamicaProps) => {
            const novaLista = filteredList.map((item: OpcaoProps) => {
                if (item.idConfiguracaoPropriedadeOpcao === opcaoEditada?.idConfiguracaoPropriedadeOpcao) {
                    return { ...item, ...opcaoEditada };
                }
                return item;
            });

            return {
                ...prevState,
                configuracaoPropriedadeOpcaoList: novaLista,
            };
        });
    };

    const handleSaveOption = (opcaoData: OpcaoProps | null) => {
        const opcaoExiste = filteredList.some((item: any) => item.idConfiguracaoPropriedadeOpcao === opcaoData?.idConfiguracaoPropriedadeOpcao);

        if (opcaoExiste && opcaoData?.idConfiguracaoPropriedadeOpcao) {
            handleEditOption(opcaoData);
        } else {
            setContent((prevState: ColunaDinamicaProps) => {
                return {
                    ...prevState,
                    configuracaoPropriedadeOpcaoList: [
                        ...(prevState.configuracaoPropriedadeOpcaoList || []),
                        {
                            dsConfiguracaoPropriedadeOpcao: opcaoData?.dsConfiguracaoPropriedadeOpcao,
                            vlConfiguracaoPropriedadeOpcao: opcaoData?.dsChave,
                            nrSequencia: opcaoData?.nrSequencia,
                        },
                    ],
                    tipoConfiguracaoPropriedadeEnum: 'OPCAO',
                };
            });
        }
    };

    return { filteredList, handleSaveOption, handleRemoveOption };
}
